export default __webpack_public_path__ + "static/media/stamp.d0dd2b77.svg";